import {
  Middleware,
  PreloadedState,
  Reducer,
  configureStore,
} from '@reduxjs/toolkit';
import { TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux';

export type API = {
  // * Redux integration
  reducerPath: string;
  reducer: Reducer;
  middleware: Middleware;
  // * There are more types but we only need the above for now.
};

export function rootReducer(apis: API[]) {
  return apis.reduce((acc: { [reducerPath: string]: Reducer }, element) => {
    acc[element.reducerPath] = element.reducer;
    return acc;
  }, {});
}

export const setupStore = (
  apis: API[],
  preloadedState?: PreloadedState<RootState>
) =>
  configureStore({
    reducer: rootReducer(apis),
    middleware: (getDefaultMiddleware) =>
      getDefaultMiddleware().concat(apis.map((api) => api.middleware)),
    preloadedState,
  });

export const storeActions = {};

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof rootReducer>;
export type AppStore = ReturnType<typeof setupStore>;
export type AppDispatch = AppStore['dispatch'];

// Use throughout your app instead of plain `useDispatch` and `useSelector`
export const useAppDispatch: () => AppDispatch = useDispatch;
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
